import TableCell from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';

export const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: 600,
  fontSize: 13,
}));

export const StyledTableCellBody = styled(TableCell)({
  fontSize: 13,
});
